import { render } from "./Error.vue?vue&type=template&id=687323e4&scoped=true"
import script from "./Error.vue?vue&type=script&lang=js"
export * from "./Error.vue?vue&type=script&lang=js"

import "./Error.vue?vue&type=style&index=0&id=687323e4&scoped=true&lang=css"

import exportComponent from "/Users/alexmeister/Documents/GitHub/inclusion_score/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687323e4"]])

export default __exports__